import { render, staticRenderFns } from "./RouterSummaryHeader.vue?vue&type=template&id=6b6f8534"
import script from "./RouterSummaryHeader.vue?vue&type=script&lang=ts"
export * from "./RouterSummaryHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports